import styled from 'styled-components'

export const Container = styled.div.attrs(props => ({
  role: 'navigation',
  'aria-label': 'breadcrumbs'
}))`
  position: relative;
  width: 100%;
`

export const BreadCrumbsList = styled.ol`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
`

export const CrumbDivider = styled.span<{ divider?: string }>`
  position: relative;
  font-family: Inter;
  font-size: 12px;
  line-height: 15px;
  color: ${props => props.theme.colors.color6b7786};

  &::after {
    content: '>';
  }
`
